import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CustomDatePipe, DateFormats } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'log-changes',
	templateUrl: './log-changes.component.html',
	imports: [NgClass, TranslatePipe]
})
export class LogChangesComponent {

	@Input() previousEntity: Record<string, unknown> | null = null;
	@Input() currentEntity: Record<string, unknown> | null = null;
	@Input() hideUnchanged = false;

	
	constructor(private readonly customDate: CustomDatePipe) {
	}

	getLoggedEntityValueKeys(): string[] {
		const keysOld = this.previousEntity ? Object.keys(this.previousEntity) : [];
		const keysNew = this.currentEntity ? Object.keys(this.currentEntity) : [];
		return [...new Set(keysOld.concat(keysNew))];
	}

	isDifferent(key: string): boolean {
		return !this.previousEntity || !this.currentEntity || this.previousEntity[key] !== this.currentEntity[key];
	}

	displayValue(value : unknown): unknown  {

		if (value instanceof Date) 
			return this.formatDate(value);
				
		if (typeof(value) === 'string') {
			let regex = new RegExp(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2}) (\+|-)(\d{2}):(\d{2})/); // 2022-09-29 08:17:43 +00:00
			if (regex.test(value))
				return this.formatDate(new Date(Date.parse(value)));
		}
		return value;
	}

	formatDate(date: Date): string {
		if (this.customDate.transform(date, DateFormats.TIME_SHORT) == '00:00')
			return this.customDate.transform(date, DateFormats.DATE_SHORT);
		return this.customDate.transform(date, DateFormats.DATETIME);
	}
}
